module.exports = __webpack_public_path__ + "static/img/siliconwork-renewal.7dc754c.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project/siliconwork-renewal.jpg
// module id = KS7U
// module chunks = 0